/**
 * B2B Animator Module
 * Animiert Zahlenwerte von Start zu Ziel
 */

window.B2BAnimator = (function() {
  const activeAnimations = {};

  // Easing Funktion für weichen Stop (EaseOutQuart)
  function easeOutQuart(x) {
    return 1 - Math.pow(1 - x, 4);
  }

  // Formatierungs-Helper
  function formatValue(value, type, options = {}) {
    const locale = 'de-DE';
    
    switch (type) {
      case 'currency':
        return value.toLocaleString(locale, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }) + " €";
        
      case 'percent':
        return Math.round(value) + " %";
        
      case 'int':
        return Math.round(value);
        
      case 'weight':
        const unit = options.unit || 'g';
        // Smart Logic: Ab 1000g auf kg wechseln
        if (unit === 'g' && value >= 1000) {
          return (value / 1000).toLocaleString(locale, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2
          }) + " kg";
        }
        return Math.round(value).toLocaleString(locale) + " " + unit;
        
      default:
        return value;
    }
  }

  return {
    /**
     * Startet die Animation für ein Element
     * @param {string} elementId - ID des HTML Elements
     * @param {number} startValue - Alter Wert (Startpunkt)
     * @param {number} endValue - Neuer Wert (Zielpunkt)
     * @param {string} type - 'currency', 'percent', 'int', 'weight'
     * @param {object} options - z.B. { unit: 'g' } für Gewicht
     */
    animate: function(elementId, startValue, endValue, type, options = {}) {
      const element = document.getElementById(elementId);
      if (!element) return;

      // Wenn Start und Ende gleich sind, sofort setzen und abbrechen
      if (startValue === endValue) {
        element.innerText = formatValue(endValue, type, options);
        return;
      }

      // Falls Animation läuft -> Stoppen
      if (activeAnimations[elementId]) {
        cancelAnimationFrame(activeAnimations[elementId]);
      }

      const duration = 600; // Dauer in ms
      let startTime = null;

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const ease = easeOutQuart(progress);
        
        const currentVal = startValue + (endValue - startValue) * ease;
        
        element.innerText = formatValue(currentVal, type, options);

        if (progress < 1) {
          activeAnimations[elementId] = requestAnimationFrame(step);
        } else {
          // Sicherstellen, dass der Endwert exakt steht
          element.innerText = formatValue(endValue, type, options);
          delete activeAnimations[elementId];
        }
      }

      activeAnimations[elementId] = requestAnimationFrame(step);
    }
  };
})();